import React, { Component } from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { LoginMenu } from "./api-authorization/LoginMenu";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  logo() {
    return (
      <svg
        width="136"
        height="24"
        viewBox="0 0 136 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5377 21.1125L0.159935 3.84826C-0.197742 3.34804 0.0678061 2.94574 0.682903 2.94574H4.6851C5.27039 2.94574 5.66058 3.16277 5.97761 3.60741L17.5534 19.8183C17.8839 20.2814 18.3012 20.2814 18.6318 19.8183L30.1452 3.61006C30.4623 3.16542 30.8525 2.94839 31.4377 2.94839H35.318C35.9331 2.94839 36.1986 3.35068 35.841 3.8509L23.4659 21.1151C22.0297 23.116 20.8483 24.0026 18.0465 24.0026C15.5834 24.0026 13.9468 23.0843 12.535 21.1151L12.5377 21.1125ZM43.111 6.28584C48.9612 6.28584 52.7494 8.75254 52.7494 14.2867C52.7494 14.7975 52.7195 15.3983 52.6572 15.9118C52.5949 16.3617 52.2887 16.5734 51.8579 16.5734H37.5535C38.3068 19.8156 41.4771 20.0935 44.4388 20.0935C47.0265 20.0935 48.9639 19.8818 50.8743 19.4027C51.3972 19.2519 51.6736 19.4319 51.6736 19.9744V22.0203C51.6736 22.5311 51.427 22.8937 50.8743 23.0419C48.6252 23.7036 46.6255 24.0053 44.2247 24.0053C37.2365 24.0053 32.863 21.4195 32.863 15.2845C32.863 9.75033 36.5265 6.29113 43.1165 6.29113L43.111 6.28584ZM48.2405 13.2625C47.8096 10.8699 46.0781 9.89325 43.1435 9.89325C40.209 9.89325 38.2146 10.9096 37.5914 13.2625H48.2432H48.2405ZM55.1501 13.3816C55.1501 8.41906 58.5074 6.25408 62.8781 6.25408C63.71 6.25408 64.4795 6.31495 65.0946 6.40494C65.5255 6.49493 65.7423 6.76489 65.7423 7.18571V9.83238C65.7423 10.2823 65.4957 10.494 65.035 10.4332C64.634 10.4041 64.2655 10.3723 63.897 10.3723C60.9705 10.3723 59.7701 11.5448 59.7701 13.6515V22.8249C59.7701 23.2748 59.4937 23.5474 59.0304 23.5474H55.8899C55.4292 23.5474 55.1501 23.2775 55.1501 22.8249V13.3842V13.3816ZM76.1799 6.25408C78.7054 6.25408 81.3527 6.64579 82.9243 7.03485C83.3254 7.12484 83.5096 7.3948 83.5096 7.7865V10.3723C83.5096 10.8222 83.263 11.0049 82.8024 10.8831C80.7403 10.4623 78.2149 10.1023 75.7816 10.0706C73.3808 10.0415 72.1805 10.4014 72.1805 11.2748C72.1805 12.3282 73.1668 12.5082 76.459 12.9581C81.5695 13.6489 84.6802 14.3105 84.6802 18.2805C84.6802 21.9197 82.2171 23.9947 75.4727 23.9947C72.7928 23.9947 70.1157 23.603 68.2975 23.0922C67.929 23.0022 67.742 22.7322 67.742 22.3405V19.6939C67.742 19.2122 67.9886 19.0613 68.4817 19.2122C70.6359 19.813 73.4377 20.1438 75.8087 20.1438C78.8869 20.1438 80.1198 19.4821 80.1198 18.6405C80.1198 17.558 79.0116 17.2272 74.3916 16.6555C69.5277 16.0547 67.5875 14.7314 67.5875 11.603C67.5875 8.17556 70.1428 6.24879 76.1772 6.24879L76.1799 6.25408ZM86.8642 7.42656C86.8642 6.97662 87.1406 6.70401 87.6039 6.70401H90.7445C91.2051 6.70401 91.4842 6.97397 91.4842 7.42656V16.1209C91.4842 19.85 94.1018 20.1809 96.3481 20.1809C98.9358 20.1809 101.366 19.7309 101.366 16.1209V7.4292C101.366 6.97927 101.643 6.70666 102.106 6.70666H105.247C105.707 6.70666 105.986 6.97662 105.986 7.4292V16.8725C105.986 22.4358 101.521 24 96.4402 24C90.9585 24 86.8642 22.015 86.8642 16.8725V7.4292V7.42656ZM108.634 13.3816C108.634 7.81826 113.129 6.25408 118.24 6.25408C123.751 6.25408 127.878 8.23908 127.878 13.3816V22.8249C127.878 23.2748 127.601 23.5474 127.138 23.5474H123.998C123.537 23.5474 123.258 23.2775 123.258 22.8249V14.1359C123.258 10.4067 120.611 10.0759 118.332 10.0759C115.714 10.0759 113.251 10.5258 113.251 14.1359V22.8275C113.251 23.2775 112.975 23.5501 112.511 23.5501H109.371C108.91 23.5501 108.631 23.2801 108.631 22.8275V13.3842L108.634 13.3816ZM130.311 2.07499C130.311 0.751654 131.143 0 132.56 0H133.208C134.655 0 135.487 0.751654 135.487 2.07499V2.70754C135.487 3.94089 134.655 4.63167 133.208 4.63167H132.56C131.143 4.63167 130.311 3.94089 130.311 2.70754V2.07499ZM130.588 7.4292C130.588 6.97927 130.864 6.70666 131.327 6.70666H134.468C134.928 6.70666 135.208 6.97662 135.208 7.4292V17.3939C135.208 17.9259 135.099 18.307 134.788 18.7437L131.579 23.2192C131.387 23.4865 131.268 23.6109 131.021 23.6109C130.775 23.6109 130.59 23.3992 130.59 22.9493V7.4292H130.588Z"
          fill="url(#paint0_linear_426_23)"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_426_23"
            x1="45.3086"
            y1="41.8227"
            x2="83.337"
            y2="-13.7778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#000087"></stop>
            <stop offset="0.25" stop-color="#003B97"></stop>
            <stop offset="0.5" stop-color="#0071A6"></stop>
            <stop offset="0.72" stop-color="#0099B0"></stop>
            <stop offset="0.89" stop-color="#00B2B7"></stop>
            <stop offset="1" stop-color="#00BBBA"></stop>
          </linearGradient>
        </defs>
      </svg>
    );
  }
  render() {
    return (
      <header>
        <Navbar bg="dark" variant="dark">
          <Container>
            <Navbar.Brand href="/">{this.logo()}</Navbar.Brand>
            <Nav className="me-auto">
              <Nav.Link href="/dashboard">Dashboard</Nav.Link>
              <Nav.Link href="/details/1/0/0">Station Analytics</Nav.Link>
              <Nav.Link href="/reports">Reports</Nav.Link>
              <Nav.Link href="/comparison">Comparison</Nav.Link>
            </Nav>
            <Nav className="mL-auto">
              <NavDropdown menuVariant="dark" title="Configuration" id="config-nav-dropdown">
                <NavDropdown.Item href="/offsets">Offsets</NavDropdown.Item>
                <NavDropdown.Item href="/notifications">
                  Notifications
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/about">
                  About
                </NavDropdown.Item>
              </NavDropdown>
              <LoginMenu></LoginMenu>
            </Nav>
          </Container>
        </Navbar>
      </header>
    );
  }
}
